import { Action, combineReducers } from 'redux';
import { ThunkAction } from 'redux-thunk';
import articlesReducer from './articles';
import creatorReducer  from './creator';
import vacancyReducer  from './vacancy';

const rootReducers = combineReducers({
    articles: articlesReducer,
    vacancies: vacancyReducer,
    creator: creatorReducer
})

export type RootState = ReturnType<typeof rootReducers>;
export type AppThunk = ThunkAction<void, typeof rootReducers, null, Action<string>>;

export default rootReducers;